<div id="forgot-password" class="inner-scroll flex flex-row">
  <div id="forgot-password-intro" class="flex-1 xs:hidden">
    <div class="logo zoom-in">
      <img src="assets/images/logos/fluid-logo.png" alt="Logo" />
    </div>

    <div class="title delay-50! slide-up">
      {{ 'Benvenuto su FLUID!' | translate }}
    </div>

    <div class="description delay-100! slide-up">
      {{
        'Se la email esiste nel nostro database riceverai le istruzioni per resettare la password nella casella di posta. Accertati di controllare anche la tua cartella spam/posta indesiderata.'
          | translate
      }}
      <br />
      {{ 'Per supporto inviare una email a' | translate }}
      <a [href]="'mailto:' + SUPPORT_EMAIL">{{ SUPPORT_EMAIL }}</a>
    </div>
  </div>

  <div id="forgot-password-form-wrapper" class="flex flex-col delay-300! slide-left">
    <div id="forgot-password-form" class="flex-1 p-24 pt-128">
      <div>
        <div class="logo gt-xs:hidden zoom-in">
          <img
            [src]="
              ThemeService.isDarkMode()
                ? 'assets/images/logos/fluid-logo.png'
                : 'assets/images/logos/fluid-logo-alt.png'
            "
            alt="FluidNext Logo"
          />
        </div>
        <div class="title">{{ 'Recupero Password' | translate }}</div>
        <div class="gt-xs:hidden description delay-100! slide-up">
          {{
            'Se la mail esiste nel nostro database riceverai le istruzioni per resettare la password nella casella di posta. Accertati di controllare anche la tua cartella spam/posta indesiderata.'
              | translate
          }}<br />
          {{ 'Per supporto inviare una email a' | translate }}
          <a [href]="'mailto:' + SUPPORT_EMAIL">{{ SUPPORT_EMAIL }}</a>
        </div>
        <form name="forgoPasswordForm" [formGroup]="forgotPasswordForm" novalidate>
          <mat-form-field>
            <input
              name="email"
              required
              matInput
              [placeholder]="'Email' | translate"
              formControlName="email"
              [disabled]="emailSent()"
              (keypress)="keypressEvent($event)"
            />
            <mat-error appGlobalErrors></mat-error>
          </mat-form-field>

          <button
            #submitButton
            type="button"
            mat-raised-button
            class="submit-button"
            color="primary"
            aria-label="SEND RESET LINK"
            [form]="forgotPasswordForm"
            [onSubmit]="onSubmit"
            [disabled]="emailSent()"
            [class.loading]="emailSent()"
            (beforeSubmit)="beforeSubmit()"
            (afterSubmit)="afterSubmit($event)"
            [successMessage]="''"
          >
            {{ 'INVIA RICHIESTA' | translate }}
          </button>
        </form>
      </div>

      <div class="login text-right">
        <a class="link" [routerLink]="'/auth/login'">{{ 'Torna al login' | translate }}</a>
      </div>
    </div>

    <div class="text-right mt-24 mr-24">
      <img class="inline-block" src="assets/images/positivessl_trust_seal_lg_120.png" width="120" alt="Logo" />
    </div>

    @let _currentLanguage = currentLanguage();
    @if (languages?.length && _currentLanguage) {
      <div class="pt-24 mb-24 pr-12 text-right">
        <!-- LANGUAGES -->
        <button mat-button class="language-button" [matMenuTriggerFor]="languageMenu">
          <div class="flex flex-row items-center gap-4">
            <img class="flag" [src]="_currentLanguage.imagePath" alt="Flag" />
            <span class="iso uppercase">{{ _currentLanguage.code }}</span>
          </div>
        </button>
        <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
          @for (lang of languages; track lang.code) {
            <button mat-menu-item (click)="setLanguage(lang)">
              <span class="flex flex-row items-center gap-4">
                <img class="flag" [src]="lang.imagePath" alt="Flag" />
                <span class="iso">{{ lang.name }}</span>
              </span>
            </button>
          }
        </mat-menu>
      </div>
    }
  </div>
</div>
